
export const RoleList = [{
  "_id": {
    "$oid": "6582b2abc34acba9c0631ec9"
  },
  "role_code": "U001",
  "role_name": "Super Admin",
  "created_date": {
    "$date": "2023-12-20T09:23:55.299Z"
  },
  "created_by": "AM1081",
  "__v": 0
},
{
  "_id": {
    "$oid": "6582b2b7c34acba9c0631ece"
  },
  "role_code": "U002",
  "role_name": "Portal User",
  "created_date": {
    "$date": "2023-12-20T09:24:07.086Z"
  },
  "created_by": "AM1081",
  "__v": 0
},
{
  "_id": {
    "$oid": "65ad544999bb5db1b46234c2"
  },
  "role_code": "U003",
  "role_name": "Admin",
  "created_date": {
    "$date": "2024-01-21T17:28:41.753Z"
  },
  "created_by": "AM001",
  "__v": 0,
  "updated_by": "AM001",
  "updated_date": {
    "$date": "2024-01-21T17:30:18.393Z"
  }
}];

export const Module_Menu = [
  {
    title: "Recruitment",
    icon: "mdi mdi-account-search-outline",
    route: "/#",
    children: [
      {
        title: "Job Setup",
        icon: "mdi mdi-wrench-outline",
        route: "/#",
        children: []
      },
      {
        title: "Resource",
        icon: "mdi mdi-account-group-outline",
        route: "/#",
        children: []
      },
      {
        title: "Onboarding",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Reports",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      }
    ]
  },
  {
    title: "Reimbursement",
    icon: "mdi mdi-bank-outline",
    route: "/#",
    children: [
      {
        title: "Master",
        icon: "mdi mdi-account-group-outline",
        route: "/#",
        children: []
      },
      {
        title: "Transactions",
        icon: "mdi mdi-wallet-outline",
        route: "/#",
        children: []
      }
    ]
  },
  {
    title: "Employee",
    icon: "mdi mdi-account-box-outline",
    route: "/#",
    children: [
      {
        title: "Policy Setup",
        icon: "mdi mdi-file-cog-outline",
        route: "/#",
        children: []
      },
      {
        title: "Organizational Setup",
        icon: "mdi mdi-home-city-outline",
        route: "/#",
        children: []
      },
      {
        title: "Reports",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      }
    ]
  },
  {
    title: "Attendance",
    icon: "mdi mdi-calendar-check-outline",
    route: "/#",
    children: [
      {
        title: "Biometric",
        icon: "mdi mdi-fingerprint",
        route: "/#",
        children: []
      },
      {
        title: "Leave Management",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Shift Management",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Extra Duty",
        icon: "mdi mdi-fingerprint",
        route: "/#",
        children: []
      },
      {
        title: "Time Deductions",
        icon: "mdi mdi-fingerprint",
        route: "/#",
        children: []
      },
      {
        title: "Reports",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: [
          {
            title: "Attendance Reports",
            icon: "mdi mdi-account-multiple-plus-outline",
            route: "/#",
            children: []
          },
          {
            title: "Leave Reports",
            icon: "mdi mdi-account-multiple-plus-outline",
            route: "/#",
            children: []
          },
          {
            title: "Shift Reports",
            icon: "mdi mdi-account-multiple-plus-outline",
            route: "/#",
            children: []
          },
          {
            title: "Statutory Reports",
            icon: "mdi mdi-account-multiple-plus-outline",
            route: "/#",
            children: []
          }
        ]
      }
    ]
  },
  {
    title: "Time Sheet",
    icon: "mdi mdi-calendar-clock",
    route: "/#",
    children: [
      {
        title: "Setup",
        icon: "mdi mdi-fingerprint",
        route: "/#",
        children: []
      },
      {
        title: "Transactions",
        icon: "mdi mdi-fingerprint",
        route: "/#",
        children: []
      },
      {
        title: "Reports",
        icon: "mdi mdi-fingerprint",
        route: "/#",
        children: []
      },
    ]
  },
  {
    title: "Payroll",
    icon: "mdi mdi-bank-transfer fs-24",
    route: "/#",
    children: [
      {
        title: "Deduction",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Salary",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Increment",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Employee Loan",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Setup",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Reports",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: [
          {
            title: "Salary Reports",
            icon: "mdi mdi-account-multiple-plus",
            route: "/#",
            children: []
          },
        ]
      },
    ]
  },
  {
    title: "Expenses",
    icon: "mdi mdi-cash-multiple",
    route: "/#",
    children: [
      {
        title: "Master",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Transaction",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Reports",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      }
    ]
  },
  {
    title: "Performance",
    icon: "mdi mdi-chart-line",
    route: "/#",
    children: [
      {
        title: "Setup",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      },
      {
        title: "Reports",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      }
    ]
  },
  {
    title: "Configuration",
    icon: "mdi mdi-tools",
    route: "/#",
    children: []
  },
  {
    title: "Setup",
    icon: "mdi mdi-cog-outline",
    route: "/#",
    children: [
      {
        title: "Holiday",
        icon: "mdi mdi-account-multiple-plus-outline",
        route: "/#",
        children: []
      }
    ]
  },
];

export const Modules = [
  { 
    "_id": "6582b4cfc221791b3c2fd1fa", 
    "module_code": "M001", 
    "module_name": "Keys-Responsibilities", 
    "module_route": "/rcrt-job-set-key-resps",
    "module_icon": "mdi mdi-account-tie",
    "main_menu": "Recruitment",
    "sub_menu": "Job Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd1f9", 
    "module_code": "M002", 
    "module_name": "Qualifications", 
    "module_route": "/rcrt-job-set-qual",
    "module_icon": "bx bx-book",
    "main_menu": "Recruitment",
    "sub_menu": "Job Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd1fb", 
    "module_code": "M003", 
    "module_name": "Position Creation", 
    "module_route": "/rcrt-job-set-poscr",
    "module_icon": "bx bx-plus",
    "main_menu": "Recruitment",
    "sub_menu": "Job Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd1fc", 
    "module_code": "M004", 
    "module_name": "Skill Mapping", 
    "module_route": "/rcrt-job-set-skill-map",
    "module_icon": "bx bx-brain",
    "main_menu": "Recruitment",
    "sub_menu": "Job Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd1fd", 
    "module_code": "M005", 
    "module_name": "Requisition", 
    "module_route": "/rcrt-resource-requisition",
    "module_icon": "mdi mdi-clipboard-text-outline",
    "main_menu": "Recruitment",
    "sub_menu": "Resource"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd1fe", 
    "module_code": "M006", 
    "module_name": "Approval", 
    "module_route": "/rcrt-resource-approval",
    "module_icon": "bx bx-check-circle",
    "main_menu": "Recruitment",
    "sub_menu": "Resource"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd1ff", 
    "module_code": "M007", 
    "module_name": "Apply Job", 
    "module_route": "/rcrt-onbd-app-job",
    "module_icon": "bx bx-briefcase",
    "main_menu": "Recruitment",
    "sub_menu": "Onboarding"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd200", 
    "module_code": "M008", 
    "module_name": "Onboard Selection", 
    "module_route": "/rcrt-onbd-selection",
    "module_icon": "bx bx-check-circle",
    "main_menu": "Recruitment",
    "sub_menu": "Onboarding"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd201", 
    "module_code": "M009", 
    "module_name": "Process", 
    "module_route": "/rcrt-onbd-process",
    "module_icon": "bx bx-loader",
    "main_menu": "Recruitment",
    "sub_menu": "Onboarding"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd202", 
    "module_code": "M010", 
    "module_name": "Master", 
    "module_route": "/setup-holiday",
    "module_icon": "bx bx-calendar",
    "main_menu": "Setup",
    "sub_menu": "Holiday"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd203", 
    "module_code": "M011", 
    "module_name": "Leave Type", 
    "module_route": "/setup-leave",
    "module_icon": "bx bx-id-card",
    "main_menu": "Setup",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd404", 
    "module_code": "M012", 
    "module_name": "Shift", 
    "module_route": "/setup-shift",
    "module_icon": "mdi mdi-clock-time-eight-outline",
    "main_menu": "Setup",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd204", 
    "module_code": "M012", 
    "module_name": "Shift Group", 
    "module_route": "/setup-shift-group",
    "module_icon": "mdi mdi-account-group-outline",
    "main_menu": "Setup",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd205", 
    "module_code": "M013", 
    "module_name": "Category", 
    "module_route": "/setup-category",
    "module_icon": "bx bx-list-ul",
    "main_menu": "Setup",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd206", 
    "module_code": "M014", 
    "module_name": "Department", 
    "module_route": "/setup-department",
    "module_icon": "mdi mdi-office-building-outline",
    "main_menu": "Setup",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd207", 
    "module_code": "M015", 
    "module_name": "Designation", 
    "module_route": "/setup-designation",
    "module_icon": "bx bx-card",
    "main_menu": "Setup",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd208", 
    "module_code": "M016", 
    "module_name": "Roles", 
    "module_route": "/manage-roles",
    "module_icon": "mdi mdi-shield-account-outline",
    "main_menu": "Configuration",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd409", 
    "module_code": "M017", 
    "module_name": "Access Rights", 
    "module_route": "/roles-access-rights",
    "module_icon": "bx bx-lock",
    "main_menu": "Configuration",
    "sub_menu": null
  },
  // { 
  //   "_id": "6582b4cfc221791b3c2fd20a", 
  //   "module_code": "M018", 
  //   "module_name": "Page Mapping", 
  //   "module_route": "/#",
  //   "module_icon": "bx bx-map",
  //   "main_menu": "Setup",
  //   "sub_menu": null
  // },
  { 
    "_id": "6582b4cfc221791b3c2fd20b", 
    "module_code": "M019", 
    "module_name": "Qualifications", 
    "module_route": "/setup-qualifications",
    "module_icon": "mdi mdi-certificate-outline",
    "main_menu": "Setup",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd20c", 
    "module_code": "M020", 
    "module_name": "Unit", 
    "module_route": "/setup-unit",
    "module_icon": "bx bx-package",
    "main_menu": "Setup",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd209", 
    "module_code": "M021", 
    "module_name": "Modules", 
    "module_route": "/manage-modules",
    "module_icon": "bx bx-lock",
    "main_menu": "Configuration",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd300", 
    "module_code": "M022", 
    "module_name": "Login Creation", 
    "module_route": "/config-login-creation",
    "module_icon": "bx bx-lock",
    "main_menu": "Configuration",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd301", 
    "module_code": "M023", 
    "module_name": "Setup", 
    "module_route": "/config-setup",
    "module_icon": "mdi mdi-cog-clockwise",
    "main_menu": "Configuration",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd302", 
    "module_code": "M024", 
    "module_name": "Employee Details", 
    "module_route": "/manage-employee",
    "module_icon": "mdi mdi-card-account-details-outline",
    "main_menu": "Employee",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd303", 
    "module_code": "M025", 
    "module_name": "Change Password", 
    "module_route": "/config-change-password",
    "module_icon": "mdi mdi-shield-key-outline",
    "main_menu": "Configuration",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd304", 
    "module_code": "M026", 
    "module_name": "Employee Exemption", 
    "module_route": "/employee-exemption",
    "module_icon": "mdi mdi-account-lock-outline",
    "main_menu": "Employee",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd305", 
    "module_code": "M027", 
    "module_name": "Employee Resignation", 
    "module_route": "/employee-resignation",
    "module_icon": "mdi mdi-account-off-outline",
    "main_menu": "Employee",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd306", 
    "module_code": "M028", 
    "module_name": "My Profile", 
    "module_route": "/my-profile",
    "module_icon": "mdi mdi-file-account-outline",
    "main_menu": "Employee",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd307", 
    "module_code": "M029", 
    "module_name": "Circular", 
    "module_route": "/employee-circular",
    "module_icon": "mdi mdi-badge-account-outline",
    "main_menu": "Employee",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd308", 
    "module_code": "M030", 
    "module_name": "Leave Policy", 
    "module_route": "/leave-policy",
    "module_icon": "mdi mdi-calendar-text-outline",
    "main_menu": "Employee",
    "sub_menu": "Policy Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd409", 
    "module_code": "M031", 
    "module_name": "Permission Policy", 
    "module_route": "/permission-policy",
    "module_icon": "mdi mdi-file-check-outline",
    "main_menu": "Employee",
    "sub_menu": "Policy Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd309", 
    "module_code": "M032", 
    "module_name": "Grace Policy", 
    "module_route": "/grace-policy",
    "module_icon": "mdi mdi-timer-sand-empty",
    "main_menu": "Employee",
    "sub_menu": "Policy Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd501", 
    "module_code": "M033", 
    "module_name": "Heads", 
    "module_route": "/reimb-master-heads",
    "module_icon": "mdi mdi-account-star-outline",
    "main_menu": "Reimbursement",
    "sub_menu": "Master"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd502", 
    "module_code": "M034", 
    "module_name": "Sub Heads", 
    "module_route": "/reimb-master-subheads",
    "module_icon": "mdi mdi-account-supervisor-outline",
    "main_menu": "Reimbursement",
    "sub_menu": "Master"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd503", 
    "module_code": "M035", 
    "module_name": "Mapping", 
    "module_route": "/reimb-master-mapping",
    "module_icon": "mdi mdi-map-marker-outline",
    "main_menu": "Reimbursement",
    "sub_menu": "Master"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd504", 
    "module_code": "M036", 
    "module_name": "Claim", 
    "module_route": "/reimb-txns-claim",
    "module_icon": "mdi mdi-account-cash-outline",
    "main_menu": "Reimbursement",
    "sub_menu": "Transactions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd505", 
    "module_code": "M037", 
    "module_name": "Claim Approval", 
    "module_route": "/reimb-txns-ca",
    "module_icon": "mdi mdi-cash-check",
    "main_menu": "Reimbursement",
    "sub_menu": "Transactions"
  },
  // { 
  //   "_id": "6582b4cfc221791b3c2fd1faaa", 
  //   "module_code": "M038", 
  //   "module_name": "Pay Slip", 
  //   "module_route": "/payslip",
  //   "module_icon": "mdi mdi-receipt-outline",
  //   "main_menu": "Payroll",
  //   "sub_menu": "Reports > Salary Reports"
  // },
  { 
    "_id": "6582b4cfc221791b3c2fd506", 
    "module_code": "M039", 
    "module_name": "Multilevel Approval", 
    "module_route": "/multilevel-approval",
    "module_icon": "mdi mdi-clipboard-check-multiple-outline",
    "main_menu": "Employee",
    "sub_menu": "Organizational Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd507", 
    "module_code": "M040", 
    "module_name": "Organization Chart", 
    "module_route": "/organization-chart",
    "module_icon": "mdi mdi-view-grid-outline",
    "main_menu": "Employee",
    "sub_menu": "Organizational Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd508", 
    "module_code": "M041", 
    "module_name": "Discrepancy", 
    "module_route": "/attnd-bio-discrepancy",
    "module_icon": "mdi mdi-alert-circle-outline",
    "main_menu": "Attendance",
    "sub_menu": "Biometric"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd509", 
    "module_code": "M042", 
    "module_name": "Mobile Punch", 
    "module_route": "/attnd-bio-mobile-punch",
    "module_icon": "mdi mdi-cellphone",
    "main_menu": "Attendance",
    "sub_menu": "Biometric"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd510", 
    "module_code": "M043", 
    "module_name": "Import Punchlist", 
    "module_route": "/attnd-bio-imp-punch",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Attendance",
    "sub_menu": "Biometric"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd519", 
    "module_code": "M044", 
    "module_name": "Apply", 
    "module_route": "/attnd-leave-apply",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd511", 
    "module_code": "M044", 
    "module_name": "Approval", 
    "module_route": "/attnd-leave-approval",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd520", 
    "module_code": "M045", 
    "module_name": "Cancel", 
    "module_route": "/attnd-leave-cancel",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd521", 
    "module_code": "M046", 
    "module_name": "AbsentList", 
    "module_route": "/attnd-leave-absentlist",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd522", 
    "module_code": "M047", 
    "module_name": "ShiftProcess", 
    "module_route": "/attnd-shift-process",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Shift Management"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd523", 
    "module_code": "M048", 
    "module_name": "ShiftChange", 
    "module_route": "/attnd-shift-change",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Shift Management"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd524", 
    "module_code": "M049", 
    "module_name": "ShiftRemoval", 
    "module_route": "/attnd-shift-removal",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Shift Management"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd513", 
    "module_code": "M050", 
    "module_name": "Claim", 
    "module_route": "/attnd-leave-extra-claim",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management > Extra Duty"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd514", 
    "module_code": "M051", 
    "module_name": "Claim Approval", 
    "module_route": "/attnd-leave-extra-claim-approval",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management > Extra Duty"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd515", 
    "module_code": "M052", 
    "module_name": "Claim Cancel", 
    "module_route": "/attnd-leave-extra-claim-cancel",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management > Extra Duty"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd516", 
    "module_code": "M053", 
    "module_name": "Payment Claim", 
    "module_route": "/attnd-leave-extra-claim-payment",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management > Extra Duty"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd517", 
    "module_code": "M054", 
    "module_name": "Payment Approval", 
    "module_route": "/attnd-leave-extra-claim-payment-approval",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management > Extra Duty"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd518", 
    "module_code": "M055", 
    "module_name": "Payment Cancel", 
    "module_route": "/attnd-leave-extra-claim-payment-cancel",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Leave Management > Extra Duty"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd601", 
    "module_code": "M056", 
    "module_name": "Late Process", 
    "module_route": "/time-deductions-shift-late",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Attendance",
    "sub_menu": "Biometric > Time Deductions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd335", 
    "module_code": "M111", 
    "module_name": "Late Approval", 
    "module_route": "/time-deductions-late-approval",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Attendance",
    "sub_menu": "Biometric > Time Deductions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd602", 
    "module_code": "M057", 
    "module_name": "Late Cancel", 
    "module_route": "/shift-late-cancel",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Attendance",
    "sub_menu": "Biometric > Time Deductions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd603", 
    "module_code": "M058", 
    "module_name": "Late Report", 
    "module_route": "/shift-late-report",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Attendance",
    "sub_menu": "Biometric > Time Deductions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd604", 
    "module_code": "M059", 
    "module_name": "Late Consoldiated Report", 
    "module_route": "/shift-late-consol-report",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Attendance",
    "sub_menu": "Biometric > Time Deductions"
  },

  { 
    "_id": "6582b4cfc221791b3c2fd605", 
    "module_code": "M060", 
    "module_name": "Salary Definition", 
    "module_route": "/payroll-salary-definition",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Salary"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd606", 
    "module_code": "M061", 
    "module_name": "Tax", 
    "module_route": "/payroll-ded-tax",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Deduction"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd607", 
    "module_code": "M062", 
    "module_name": "Fixed Deductions", 
    "module_route": "/payroll-fixed-deductions",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Deduction"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd608", 
    "module_code": "M063", 
    "module_name": "Salary Generation", 
    "module_route": "/payroll-salary-generation",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Salary"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd609", 
    "module_code": "M064", 
    "module_name": "Stop Payment", 
    "module_route": "/payroll-salary-stop-payment",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Salary"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd7010", 
    "module_code": "M065", 
    "module_name": "Extra Payment", 
    "module_route": "/payroll-salary-extra-payment",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Salary"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd7011", 
    "module_code": "M066", 
    "module_name": "Allowance", 
    "module_route": "/payroll-salary-allowance",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Salary"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd611", 
    "module_code": "M067", 
    "module_name": "Increment Update", 
    "module_route": "/payroll-increment-update",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Increment"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd612", 
    "module_code": "M068", 
    "module_name": "Increment Approval", 
    "module_route": "/payroll-increment-approval",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Increment"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd613", 
    "module_code": "M069", 
    "module_name": "Increment Report", 
    "module_route": "/payroll-increment-report",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Increment"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd614", 
    "module_code": "M070", 
    "module_name": "Employee Increment Report", 
    "module_route": "/payroll-emp-increment-report",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Increment"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd615", 
    "module_code": "M071", 
    "module_name": "Monthly Deductions", 
    "module_route": "/payroll-monthly-deductions",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Deduction"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd725", 
    "module_code": "M072", 
    "module_name": "Full & Final Settlement", 
    "module_route": "/payroll-settlement",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Deduction"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd616", 
    "module_code": "M073", 
    "module_name": "Allowances", 
    "module_route": "/payroll-allowance",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd617", 
    "module_code": "M074", 
    "module_name": "Deductions", 
    "module_route": "/payroll-deduction",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd618", 
    "module_code": "M075", 
    "module_name": "Salary Setup", 
    "module_route": "/payroll-salary-setup",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd619", 
    "module_code": "M076", 
    "module_name": "Loan Apply", 
    "module_route": "/payroll-loan-apply",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Employee Loan"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd620", 
    "module_code": "M077", 
    "module_name": "Loan Pre Close", 
    "module_route": "/payroll-loan-pre-close",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Employee Loan"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd621", 
    "module_code": "M078", 
    "module_name": "Loan Freeze", 
    "module_route": "/payroll-loan-freeze",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Employee Loan"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd622", 
    "module_code": "M079", 
    "module_name": "Loan Approval", 
    "module_route": "/payroll-loan-approval",
    "module_icon": "mdi mdi-clock-check-outline",
    "main_menu": "Payroll",
    "sub_menu": "Employee Loan"
  },
  // {
  //   "_id": "6582b4cfc221791b3c2fd210", 
  //   "module_code": "M022", 
  //   "module_name": "Dashboards", 
  //   "module_route": "/dashboard", 
  //   "module_icon": "mdi mdi-home-outline", 
  //   "main_menu": "Dashboards", 
  //   "sub_menu": "Dashboards"
  // },
  // {
  //   "_id": "6582b4cfc221791b3c2fd211", 
  //   "module_code": "M023", 
  //   "module_name": "HR Dashboards", 
  //   "module_route": "/hr-dashboard", 
  //   "module_icon": "mdi mdi-home-outline", 
  //   "main_menu": "HR Dashboards", 
  //   "sub_menu": "HR Dashboards"
  // }
  { 
    "_id": "6582b4cfc221791b3c2fd304", 
    "module_code": "M080", 
    "module_name": "Process", 
    "module_route": "/holiday-process",
    "module_icon": "bx bx-calendar",
    "main_menu": "Setup",
    "sub_menu": "Holiday"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd305", 
    "module_code": "M081", 
    "module_name": "Remove", 
    "module_route": "/holiday-remove",
    "module_icon": "bx bx-calendar",
    "main_menu": "Setup",
    "sub_menu": "Holiday"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd306", 
    "module_code": "M082", 
    "module_name": "Self Appraisal", 
    "module_route": "/perfor-self-appraisal",
    "module_icon": "bx bx-calendar",
    "main_menu": "Performance",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd307", 
    "module_code": "M083", 
    "module_name": "Manager Appraisal", 
    "module_route": "/perfor-manager-appraisal",
    "module_icon": "bx bx-calendar",
    "main_menu": "Performance",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd308", 
    "module_code": "M084", 
    "module_name": "KRA Factor", 
    "module_route": "/perfor-kra-factor",
    "module_icon": "bx bx-calendar",
    "main_menu": "Performance",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd309", 
    "module_code": "M085", 
    "module_name": "KPI Factor", 
    "module_route": "/perfor-kpi-factor",
    "module_icon": "bx bx-calendar",
    "main_menu": "Performance",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd310", 
    "module_code": "M086", 
    "module_name": "KRA KPI Mapping", 
    "module_route": "/perfor-kra-kpi-mapping",
    "module_icon": "bx bx-calendar",
    "main_menu": "Performance",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd311", 
    "module_code": "M087", 
    "module_name": "Yearly Fixing", 
    "module_route": "/perfor-yearly-fixing",
    "module_icon": "bx bx-calendar",
    "main_menu": "Performance",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd312", 
    "module_code": "M088", 
    "module_name": "Service", 
    "module_route": "/time-setup-service",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd313", 
    "module_code": "M089", 
    "module_name": "Client", 
    "module_route": "/time-setup-client",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd314", 
    "module_code": "M090", 
    "module_name": "Project", 
    "module_route": "/time-setup-project",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd315", 
    "module_code": "M091", 
    "module_name": "Module", 
    "module_route": "/time-setup-module",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd316", 
    "module_code": "M092", 
    "module_name": "Task", 
    "module_route": "/time-setup-task",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd317", 
    "module_code": "M093", 
    "module_name": "Task Type", 
    "module_route": "/time-setup-tasktype",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Setup"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd318", 
    "module_code": "M094", 
    "module_name": "Apply", 
    "module_route": "/time-trans-apply",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Transactions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd319", 
    "module_code": "M095", 
    "module_name": "Approval", 
    "module_route": "/time-trans-approval",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Transactions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd320", 
    "module_code": "M096", 
    "module_name": "HR Approval", 
    "module_route": "/time-trans-hr-appr",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Transactions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd321", 
    "module_code": "M097", 
    "module_name": "Final Approval", 
    "module_route": "/time-trans-final-appr",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Transactions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd322", 
    "module_code": "M098", 
    "module_name": "Project Billing Report", 
    "module_route": "/time-project-bill-report",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Transactions"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd323", 
    "module_code": "M099", 
    "module_name": "Employee Report", 
    "module_route": "/payroll-employee-report",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd324", 
    "module_code": "M100", 
    "module_name": "My Payslip", 
    "module_route": "/payroll-my-payslip",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd325", 
    "module_code": "M101", 
    "module_name": "Pay Slip", 
    "module_route": "/payroll-pay-slip",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd326", 
    "module_code": "M102", 
    "module_name": "Bank Statement", 
    "module_route": "/payroll-bank-statement",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd327", 
    "module_code": "M103", 
    "module_name": "Wages Register", 
    "module_route": "/payroll-wages-register",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd328", 
    "module_code": "M104", 
    "module_name": "Section-Wages Register", 
    "module_route": "/payroll-sec-wages-register",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd329", 
    "module_code": "M105", 
    "module_name": "Monthly ESI Register", 
    "module_route": "/payroll-esi-register",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd330", 
    "module_code": "M106", 
    "module_name": "Monthly PF Register", 
    "module_route": "/payroll-pf-register",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd331", 
    "module_code": "M107", 
    "module_name": "Pay Register Summary", 
    "module_route": "/payroll-pay-register",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd332", 
    "module_code": "M108", 
    "module_name": "Current CTC Report", 
    "module_route": "/payroll-current-ctc-report",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd333", 
    "module_code": "M109", 
    "module_name": "Individual Pay Register", 
    "module_route": "/payroll-individual-pay-register",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd334", 
    "module_code": "M110", 
    "module_name": "Monthly ProfTax Register", 
    "module_route": "/payroll-mon-prof-tax-register",
    "module_icon": "bx bx-calendar",
    "main_menu": "Payroll",
    "sub_menu": "Reports > Salary Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd335", 
    "module_code": "M112", 
    "module_name": "Monthly Timesheet Report", 
    "module_route": "/time-reports-monthly-timesheet",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd336", 
    "module_code": "M113", 
    "module_name": "Project Revenue Report", 
    "module_route": "/time-reports-project-revenue",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd337", 
    "module_code": "M114", 
    "module_name": "Employee Day Wise Timesheet", 
    "module_route": "/time-reports-emp-day-wise",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd338", 
    "module_code": "M115", 
    "module_name": "Task Status", 
    "module_route": "/time-reports-task-status",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd339", 
    "module_code": "M116", 
    "module_name": "Employee Task Status", 
    "module_route": "/time-reports-emp-task-status",
    "module_icon": "bx bx-calendar",
    "main_menu": "Time Sheet",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd340", 
    "module_code": "M117", 
    "module_name": "Activity", 
    "module_route": "/employee-report-activity",
    "module_icon": "bx bx-calendar",
    "main_menu": "Employee",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd341", 
    "module_code": "M118", 
    "module_name": "My Activity", 
    "module_route": "/employee-report-my-activity",
    "module_icon": "bx bx-calendar",
    "main_menu": "Employee",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd342", 
    "module_code": "M119", 
    "module_name": "Exemption / Resigned", 
    "module_route": "/employee-report-exemption",
    "module_icon": "bx bx-calendar",
    "main_menu": "Employee",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd343", 
    "module_code": "M120", 
    "module_name": "Age Wise Search", 
    "module_route": "/employee-report-age-wise",
    "module_icon": "bx bx-calendar",
    "main_menu": "Employee",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd344", 
    "module_code": "M121", 
    "module_name": "BirthDay", 
    "module_route": "/employee-report-birthday",
    "module_icon": "bx bx-calendar",
    "main_menu": "Employee",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd345", 
    "module_code": "M122", 
    "module_name": "Consolidate", 
    "module_route": "/attnd-report-consolidate",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd346", 
    "module_code": "M123", 
    "module_name": "Day Wise Attendance", 
    "module_route": "/attnd-report-day-wise",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd347", 
    "module_code": "M124", 
    "module_name": "Month Wise Attendance", 
    "module_route": "/attnd-report-month-wise",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd348", 
    "module_code": "M125", 
    "module_name": "Late In & Out", 
    "module_route": "/attnd-report-lateinout",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd349", 
    "module_code": "M126", 
    "module_name": "Late Comers List", 
    "module_route": "/attnd-report-late-comers",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd350", 
    "module_code": "M127", 
    "module_name": "Late Out List", 
    "module_route": "/attnd-report-late-out",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd351", 
    "module_code": "M128", 
    "module_name": "Present Days", 
    "module_route": "/attnd-report-present-days",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd352", 
    "module_code": "M129", 
    "module_name": "Extra Hourse Report", 
    "module_route": "/attnd-report-extra-hourse",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd353", 
    "module_code": "M130", 
    "module_name": "Attendance Checklist", 
    "module_route": "/attnd-report-checklist",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd354", 
    "module_code": "M131", 
    "module_name": "Daywise Abstract", 
    "module_route": "/attnd-report-day-abstract",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd355", 
    "module_code": "M132", 
    "module_name": "Absenteeism", 
    "module_route": "/attnd-report-absenteeism",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd356", 
    "module_code": "M133", 
    "module_name": "Long Absent", 
    "module_route": "/attnd-report-long-absent",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd357", 
    "module_code": "M134", 
    "module_name": "Mobile Punch Report", 
    "module_route": "/attnd-report-mobile-punch",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd358", 
    "module_code": "M135", 
    "module_name": "Break in service", 
    "module_route": "/attnd-report-break-in-service",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Attendance Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd359", 
    "module_code": "M136", 
    "module_name": "Leave", 
    "module_route": "/attnd-report-leave",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Leave Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd360", 
    "module_code": "M137", 
    "module_name": "Permission & OD", 
    "module_route": "/attnd-report-permission-od",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Leave Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd361", 
    "module_code": "M138", 
    "module_name": "Leave Balance", 
    "module_route": "/attnd-report-leave-balance",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Leave Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd362", 
    "module_code": "M139", 
    "module_name": "Shift Details", 
    "module_route": "/attnd-report-shift-details",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Shift Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd363", 
    "module_code": "M140", 
    "module_name": "Employee Shift", 
    "module_route": "/attnd-report-employee-shift",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Shift Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd364", 
    "module_code": "M141", 
    "module_name": "Shift Log", 
    "module_route": "/attnd-report-shift-log",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Shift Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd365", 
    "module_code": "M142", 
    "module_name": "Form 6", 
    "module_route": "/attnd-report-form-6",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Statutory Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd366", 
    "module_code": "M143", 
    "module_name": "Form 34", 
    "module_route": "/attnd-report-form-34",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Statutory Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd367", 
    "module_code": "M144", 
    "module_name": "Form 25 & 26", 
    "module_route": "/attnd-report-form-25-26",
    "module_icon": "bx bx-lock",
    "main_menu": "Attendance",
    "sub_menu": "Reports > Statutory Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd368", 
    "module_code": "M145", 
    "module_name": "New Joinee", 
    "module_route": "/rcrt-report-new-joinee",
    "module_icon": "bx bx-lock",
    "main_menu": "Recruitment",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd369", 
    "module_code": "M146", 
    "module_name": "Resource", 
    "module_route": "/rcrt-report-resource",
    "module_icon": "bx bx-lock",
    "main_menu": "Recruitment",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd370", 
    "module_code": "M147", 
    "module_name": "On Roll", 
    "module_route": "/rcrt-report-on-roll",
    "module_icon": "bx bx-lock",
    "main_menu": "Recruitment",
    "sub_menu": "Reports"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd371", 
    "module_code": "M148", 
    "module_name": "Employee Mass Transfer", 
    "module_route": "/employee-mass-transfer",
    "module_icon": "bx bx-lock",
    "main_menu": "Employee",
    "sub_menu": null
  },
  { 
    "_id": "6582b4cfc221791b3c2fd372", 
    "module_code": "M149", 
    "module_name": "Heads", 
    "module_route": "/expenses-master-heads",
    "module_icon": "bx bx-lock",
    "main_menu": "Expenses",
    "sub_menu": "Master"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd373", 
    "module_code": "M150", 
    "module_name": "Sub Heads", 
    "module_route": "/expenses-master-sub-heads",
    "module_icon": "bx bx-lock",
    "main_menu": "Expenses",
    "sub_menu": "Master"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd374", 
    "module_code": "M151", 
    "module_name": "Expense Entry", 
    "module_route": "/expenses-trans-entry",
    "module_icon": "bx bx-lock",
    "main_menu": "Expenses",
    "sub_menu": "Transaction"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd375", 
    "module_code": "M152", 
    "module_name": "Approval", 
    "module_route": "/expenses-trans-Approval",
    "module_icon": "bx bx-lock",
    "main_menu": "Expenses",
    "sub_menu": "Transaction"
  },
  { 
    "_id": "6582b4cfc221791b3c2fd376", 
    "module_code": "M153", 
    "module_name": "Expense Report", 
    "module_route": "/expenses-report",
    "module_icon": "bx bx-lock",
    "main_menu": "Expenses",
    "sub_menu": "Reports"
  }, { 
    "_id": "6582b4cfc221791b3c2fd377", 
    "module_code": "M154", 
    "module_name": "Apply Job Approve", 
    "module_route": "/rcrt-onbd-app-job-approve",
    "module_icon": "bx bx-briefcase",
    "main_menu": "Recruitment",
    "sub_menu": "Onboarding"
  },
]





export const AccessRights = [
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf"
    },
    "role_code": "U001",
    "module_code": "M001",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf02"
    },
    "role_code": "U001",
    "module_code": "M002",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf03"
    },
    "role_code": "U001",
    "module_code": "M003",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf04"
    },
    "role_code": "U001",
    "module_code": "M004",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf05"
    },
    "role_code": "U001",
    "module_code": "M005",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf06"
    },
    "role_code": "U001",
    "module_code": "M006",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf07"
    },
    "role_code": "U001",
    "module_code": "M007",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf08"
    },
    "role_code": "U001",
    "module_code": "M008",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf09"
    },
    "role_code": "U001",
    "module_code": "M009",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf10"
    },
    "role_code": "U001",
    "module_code": "M010",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf11"
    },
    "role_code": "U001",
    "module_code": "M011",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf12"
    },
    "role_code": "U001",
    "module_code": "M012",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf13"
    },
    "role_code": "U001",
    "module_code": "M013",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf14"
    },
    "role_code": "U001",
    "module_code": "M014",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf15"
    },
    "role_code": "U001",
    "module_code": "M015",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf16"
    },
    "role_code": "U001",
    "module_code": "M016",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf17"
    },
    "role_code": "U001",
    "module_code": "M017",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf18"
    },
    "role_code": "U001",
    "module_code": "M018",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf19"
    },
    "role_code": "U001",
    "module_code": "M019",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf220"
    },
    "role_code": "U001",
    "module_code": "M020",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM038",
    "updated_by": "AM038",
    "created_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "updated_date": {
      "$date": "2024-10-14T11:54:07.581Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce210"
    },
    "role_code": "U001",
    "module_code": "M021",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M022",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M023",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  ,
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M024",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M025",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M026",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M027",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M028",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce213"
    },
    "role_code": "U001",
    "module_code": "M029",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M030",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M031",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce212"
    },
    "role_code": "U001",
    "module_code": "M032",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce213"
    },
    "role_code": "U001",
    "module_code": "M033",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce214"
    },
    "role_code": "U001",
    "module_code": "M034",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce215"
    },
    "role_code": "U001",
    "module_code": "M035",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce216"
    },
    "role_code": "U001",
    "module_code": "M036",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce217"
    },
    "role_code": "U001",
    "module_code": "M037",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  // {
  //   "_id": {
  //     "$oid": "6582c8b526b6e8aa74f5ce218"
  //   },
  //   "role_code": "U001",
  //   "module_code": "M038",
  //   "read_access": 1,
  //   "edit_access": 1,
  //   "create_access": 1,
  //   "delete_access": 0,
  //   "created_by": "AM039",
  //   "updated_by": "AM039",
  //   "created_date": {
  //     "$date": "2024-10-15T10:00:10.123Z"
  //   },
  //   "updated_date": {
  //     "$date": "2024-10-15T10:00:10.123Z"
  //   },
  //   "is_active": "1"
  // },


  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce219"
    },
    "role_code": "U001",
    "module_code": "M039",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ce220"
    },
    "role_code": "U001",
    "module_code": "M040",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "updated_date": {
      "$date": "2024-10-15T10:00:10.123Z"
    },
    "is_active": "1"
  },


  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceab"
    },
    "role_code": "U001",
    "module_code": "M041",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM040",
    "updated_by": "AM040",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
    {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceac"
    },
    "role_code": "U001",
    "module_code": "M042",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cead"
    },
    "role_code": "U001",
    "module_code": "M043",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf"
    },
    "role_code": "U001",
    "module_code": "M044",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceag"
    },
    "role_code": "U001",
    "module_code": "M045",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceag"
    },
    "role_code": "U001",
    "module_code": "M046",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceag"
    },
    "role_code": "U001",
    "module_code": "M047",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceag"
    },
    "role_code": "U001",
    "module_code": "M048",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceag"
    },
    "role_code": "U001",
    "module_code": "M049",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaf"
    },
    "role_code": "U001",
    "module_code": "M050",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceai"
    },
    "role_code": "U001",
    "module_code": "M051",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaj"
    },
    "role_code": "U001",
    "module_code": "M052",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceak"
    },
    "role_code": "U001",
    "module_code": "M053",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceal"
    },
    "role_code": "U001",
    "module_code": "M054",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceam"
    },
    "role_code": "U001",
    "module_code": "M055",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cean"
    },
    "role_code": "U001",
    "module_code": "M056",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceao"
    },
    "role_code": "U001",
    "module_code": "M057",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceap"
    },
    "role_code": "U001",
    "module_code": "M058",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceaq"
    },
    "role_code": "U001",
    "module_code": "M059",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceau"
    },
    "role_code": "U001",
    "module_code": "M060",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceax"
    },
    "role_code": "U001",
    "module_code": "M061",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceay"
    },
    "role_code": "U001",
    "module_code": "M062",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceae"
    },
    "role_code": "U003",
    "module_code": "M0043",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 0,
    "delete_access": 0,
    "created_by": "AM039",
    "updated_by": "AM039",
    "created_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "updated_date": {
      "$date": "2024-10-16T12:25:20.783Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U003",
    "module_code": "M005",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M060",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M063",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M064",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M065",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M066",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M067",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M068",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M069",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M070",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M071",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cea9"
    },
    "role_code": "U001",
    "module_code": "M072",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb1"
    },
    "role_code": "U001",
    "module_code": "M073",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb2"
    },
    "role_code": "U001",
    "module_code": "M074",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb3"
    },
    "role_code": "U001",
    "module_code": "M075",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb4"
    },
    "role_code": "U001",
    "module_code": "M076",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb5"
    },
    "role_code": "U001",
    "module_code": "M077",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb6"
    },
    "role_code": "U001",
    "module_code": "M078",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb7"
    },
    "role_code": "U001",
    "module_code": "M079",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb8"
    },
    "role_code": "U001",
    "module_code": "M080",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceb9"
    },
    "role_code": "U001",
    "module_code": "M081",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec1"
    },
    "role_code": "U001",
    "module_code": "M082",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec2"
    },
    "role_code": "U001",
    "module_code": "M083",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec3"
    },
    "role_code": "U001",
    "module_code": "M084",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec4"
    },
    "role_code": "U001",
    "module_code": "M085",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec5"
    },
    "role_code": "U001",
    "module_code": "M086",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec6"
    },
    "role_code": "U001",
    "module_code": "M087",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec7"
    },
    "role_code": "U001",
    "module_code": "M088",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec8"
    },
    "role_code": "U001",
    "module_code": "M089",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cec9"
    },
    "role_code": "U001",
    "module_code": "M090",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced0"
    },
    "role_code": "U001",
    "module_code": "M091",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced1"
    },
    "role_code": "U001",
    "module_code": "M092",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced2"
    },
    "role_code": "U001",
    "module_code": "M093",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced3"
    },
    "role_code": "U001",
    "module_code": "M094",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced4"
    },
    "role_code": "U001",
    "module_code": "M095",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced5"
    },
    "role_code": "U001",
    "module_code": "M096",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced6"
    },
    "role_code": "U001",
    "module_code": "M097",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced7"
    },
    "role_code": "U001",
    "module_code": "M098",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced8"
    },
    "role_code": "U001",
    "module_code": "M099",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ced9"
    },
    "role_code": "U001",
    "module_code": "M100",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee0"
    },
    "role_code": "U001",
    "module_code": "M101",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee1"
    },
    "role_code": "U001",
    "module_code": "M102",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee2"
    },
    "role_code": "U001",
    "module_code": "M103",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee4"
    },
    "role_code": "U001",
    "module_code": "M104",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee5"
    },
    "role_code": "U001",
    "module_code": "M105",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee6"
    },
    "role_code": "U001",
    "module_code": "M106",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee7"
    },
    "role_code": "U001",
    "module_code": "M107",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee8"
    },
    "role_code": "U001",
    "module_code": "M108",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cee9"
    },
    "role_code": "U001",
    "module_code": "M109",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef0"
    },
    "role_code": "U001",
    "module_code": "M110",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef1"
    },
    "role_code": "U001",
    "module_code": "M111",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef2"
    },
    "role_code": "U001",
    "module_code": "M112",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef3"
    },
    "role_code": "U001",
    "module_code": "M113",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef4"
    },
    "role_code": "U001",
    "module_code": "M114",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef5"
    },
    "role_code": "U001",
    "module_code": "M115",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef6"
    },
    "role_code": "U001",
    "module_code": "M116",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef7"
    },
    "role_code": "U001",
    "module_code": "M117",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef8"
    },
    "role_code": "U001",
    "module_code": "M118",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cef9"
    },
    "role_code": "U001",
    "module_code": "M119",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg0"
    },
    "role_code": "U001",
    "module_code": "M120",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg1"
    },
    "role_code": "U001",
    "module_code": "M121",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg2"
    },
    "role_code": "U001",
    "module_code": "M122",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg3"
    },
    "role_code": "U001",
    "module_code": "M123",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg4"
    },
    "role_code": "U001",
    "module_code": "M124",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg5"
    },
    "role_code": "U001",
    "module_code": "M125",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg6"
    },
    "role_code": "U001",
    "module_code": "M126",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg7"
    },
    "role_code": "U001",
    "module_code": "M127",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg8"
    },
    "role_code": "U001",
    "module_code": "M128",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceg9"
    },
    "role_code": "U001",
    "module_code": "M129",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh0"
    },
    "role_code": "U001",
    "module_code": "M130",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh1"
    },
    "role_code": "U001",
    "module_code": "M131",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh2"
    },
    "role_code": "U001",
    "module_code": "M132",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh3"
    },
    "role_code": "U001",
    "module_code": "M133",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh4"
    },
    "role_code": "U001",
    "module_code": "M134",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh5"
    },
    "role_code": "U001",
    "module_code": "M135",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh6"
    },
    "role_code": "U001",
    "module_code": "M136",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh7"
    },
    "role_code": "U001",
    "module_code": "M137",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh8"
    },
    "role_code": "U001",
    "module_code": "M138",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5ceh9"
    },
    "role_code": "U001",
    "module_code": "M139",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei0"
    },
    "role_code": "U001",
    "module_code": "M140",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei1"
    },
    "role_code": "U001",
    "module_code": "M141",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei2"
    },
    "role_code": "U001",
    "module_code": "M142",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei3"
    },
    "role_code": "U001",
    "module_code": "M143",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei4"
    },
    "role_code": "U001",
    "module_code": "M144",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei5"
    },
    "role_code": "U001",
    "module_code": "M145",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei6"
    },
    "role_code": "U001",
    "module_code": "M146",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei7"
    },
    "role_code": "U001",
    "module_code": "M147",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei8"
    },
    "role_code": "U001",
    "module_code": "M148",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cei9"
    },
    "role_code": "U001",
    "module_code": "M149",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cej0"
    },
    "role_code": "U001",
    "module_code": "M150",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cej1"
    },
    "role_code": "U001",
    "module_code": "M151",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cej2"
    },
    "role_code": "U001",
    "module_code": "M152",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cej3"
    },
    "role_code": "U001",
    "module_code": "M153",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  },
  {
    "_id": {
      "$oid": "6582c8b526b6e8aa74f5cej4"
    },
    "role_code": "U001",
    "module_code": "M154",
    "read_access": 1,
    "edit_access": 1,
    "create_access": 1,
    "delete_access": 1,
    "created_by": "AM041",
    "updated_by": "AM041",
    "created_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "updated_date": {
      "$date": "2024-10-17T13:15:35.402Z"
    },
    "is_active": "1"
  }
];


export const States = [
  { value: "46", label: "Alabama" },
  { value: "47", label: "Alaska" },
  { value: "30", label: "Andaman and Nicobar" },
  { value: "24", label: "Andhra Pradesh" },
  { value: "13", label: "Arunachal Pradesh" },
  { value: "48", label: "Arizona" },
  { value: "49", label: "Arkansas" },
  { value: "3", label: "Assam" },
  { value: "4", label: "Bihar" },
  { value: "50", label: "California" },
  { value: "41", label: "Central Region" },
  { value: "31", label: "Chandigarh" },
  { value: "5", label: "Chhattisgarh" },
  { value: "51", label: "Colorado" },
  { value: "52", label: "Connecticut" },
  { value: "32", label: "Dadar and Nagar" },
  { value: "34", label: "Daman and Diu" },
  { value: "53", label: "Delaware" },
  { value: "35", label: "Delhi" },
  { value: "42", label: "East Region" },
  { value: "54", label: "Florida" },
  { value: "6", label: "Goa" },
  { value: "7", label: "Gujarat" },
  { value: "8", label: "Haryana" },
  { value: "33", label: "Haveli" },
  { value: "55", label: "Georgia" },
  { value: "56", label: "Hawaii" },
  { value: "9", label: "Himachal Pradesh" },
  { value: "57", label: "Idaho" },
  { value: "58", label: "Illinois" },
  { value: "59", label: "Indiana" },
  { value: "60", label: "Iowa" },
  { value: "10", label: "Jammu and Kashmir" },
  { value: "11", label: "Jharkhand" },
  { value: "61", label: "Kansas" },
  { value: "12", label: "Karnataka" },
  { value: "2", label: "Kerala" },
  { value: "62", label: "Kentucky" },
  { value: "36", label: "Lakshadweep" },
  { value: "63", label: "Louisiana" },
  { value: "64", label: "Maine" },
  { value: "16", label: "Manipur" },
  { value: "17", label: "Meghalaya" },
  { value: "65", label: "Maryland" },
  { value: "66", label: "Massachusetts" },
  { value: "67", label: "Michigan" },
  { value: "68", label: "Minnesota" },
  { value: "69", label: "Mississippi" },
  { value: "70", label: "Missouri" },
  { value: "18", label: "Mizoram" },
  { value: "71", label: "Montana" },
  { value: "19", label: "Nagaland" },
  { value: "72", label: "Nebraska" },
  { value: "73", label: "Nevada" },
  { value: "74", label: "New Hampshire" },
  { value: "75", label: "New Jersey" },
  { value: "76", label: "New Mexico" },
  { value: "77", label: "New York" },
  { value: "78", label: "North Carolina" },
  { value: "79", label: "North Dakota" },
  { value: "43", label: "North Region" },
  { value: "44", label: "North-East Region" },
  { value: "20", label: "Odisha" },
  { value: "80", label: "Ohio" },
  { value: "81", label: "Oklahoma" },
  { value: "82", label: "Oregon" },
  { value: "83", label: "Pennsylvania" },
  { value: "37", label: "Puducherry" },
  { value: "21", label: "Punjab" },
  { value: "22", label: "Rajasthan" },
  { value: "84", label: "Rhode Island" },
  { value: "23", label: "Sikkim" },
  { value: "85", label: "South Carolina" },
  { value: "86", label: "South Dakota" },
  { value: "1", label: "Tamil Nadu" },
  { value: "25", label: "Telangana" },
  { value: "87", label: "Tennessee" },
  { value: "88", label: "Texas" },
  { value: "26", label: "Tripura" },
  { value: "89", label: "Utah" },
  { value: "27", label: "Uttar Pradesh" },
  { value: "28", label: "Uttarakhand" },
  { value: "90", label: "Vermont" },
  { value: "91", label: "Virginia" },
  { value: "92", label: "Washington" },
  { value: "29", label: "West Bengal" },
  { value: "45", label: "West Region" },
  { value: "93", label: "West Virginia" },
  { value: "94", label: "Wisconsin" },
  { value: "95", label: "Wyoming" },
];

export const Countries = [
  { value: "1", label: "INDIA" },
  { value: "4", label: "Singapore" },
  { value: "5", label: "USA" },
];

export const LandingPages = [
  { id: 1, label: "Dashboards", path: "/dashboard", icon: "mdi mdi-view-dashboard-outline" },
  { id: 2, label: "HR Dashboards", path: "/hr-dashboard", icon: "mdi mdi-view-dashboard-outline" },
  { id: 3, label: "HOD Dashboards", path: "/hod-dashboard", icon: "mdi mdi-view-dashboard-outline" },
  { id: 4, label: "Employee Dashboard", path: "/employee-dashboard", icon: "mdi mdi-view-dashboard-outline" },
  { id: 5, label: "Payroll Dashboard", path: "/payroll-dashboard", icon: "mdi mdi-view-dashboard-outline" },
];

export const genderOptions = [
  { value: "1", label: "Male" },
  { value: "2", label: "Female" },
  { value: "3", label: "Transgender" },
];

export const leaveCategory = [
  { value: "1", label: "Leave" },
  { value: "2", label: "Permission" },
  { value: "3", label: "On Duty" },
  { value: "4", label: "Reimbursement" },
  { value: "5", label: "Extra Duty" },
];

export const sessionOptions = [
  { value: 1, label: "Session 1" },
  { value: 2, label: "Session 2" },
];

export const NotificationType = [
  { value: 1, label: "Birthday", icon: "Cake" },
  { value: 2, label: "Task", icon: "CheckSquare" },
  { value: 3, label: "Circular", icon: "FileText" },
  { value: 4, label: "Mobile Punch Approval", icon: "Smartphone" },
  { value: 5, label: "Claim Approval", icon: "ClipboardCheck" },
  { value: 6, label: "Appraisal", icon: "Award" },
  { value: 7, label: "Notice", icon: "Bell" },
  { value: 8, label: "Shift Change", icon: "Repeat" }
];

export const PROJECT_STATUS_OPTIONS = [
    { value: 1, label: "Yet to Start" },
    { value: 2, label: "Inprogress" },
    { value: 3, label: "Dropped" },
    { value: 4, label: "On Hold" },
    { value: 5, label: "Completed" },
  ];